import { render } from "./SideBar.vue?vue&type=template&id=240b0379&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=240b0379&lang=scss&scoped=true"
import "./SideBar.vue?vue&type=style&index=1&id=240b0379&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240b0379"]])

export default __exports__